/**
 * This file is based on code from the placemark repository
 * (https://github.com/placemark/placemark), licensed under the MIT License.
 *
 * Modifications made by ACT Corp are proprietary
 */
import { rough } from "../roughly_geojson";
import type { FileType, ImportOptions } from "./";
import { readAsText } from "src/lib/utils";
import { GeoJSONResult, okResult } from "./utils";

export class CGeoJSON implements FileType {
  id = "geojson" as const;
  label = "GeoJSON";
  extensions = [".geojson", ".json"];
  filenames = [] as string[];
  mimes = [] as string[];
  async forwardBinary(file: ArrayBuffer, options?: ImportOptions) {
    const text = readAsText(file)
    return await this.forwardString(text, options);
  }
  async forwardString(text: string, options?: ImportOptions) {
    const object = await JSON.parse(text);
    const result = await rough(object, {
      // Default to true unless options are provided
      removeCoincidents: options?.removeCoincidents !== false,
    });
    return result as GeoJSONResult;
  }
  /*
  async back({ featureMap }: { featureMap: FeatureMap }, options: ExportOptions) {
    return {
      blob: stringToBlob(geojsonToString(featureMap, options.geojsonOptions)),
      name: "features.geojson",
    };
  }
    */
}

export const GeoJSON = new CGeoJSON();
